import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { getSitesWord } from "./GetSitesWord";

interface DeactivateConfirmDialogProps {
  open: boolean;
  count: number;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeactivateConfirmDialog(props: DeactivateConfirmDialogProps) {
  const { open, count, onClose, onConfirm } = props;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Удаление сайтов</DialogTitle>
      <DialogContent>
        <Typography>
          Удалить {count} {getSitesWord(count)}? Удалённые сайты
          будут исключены из выборки для публикации.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Удалить
        </Button>
      </DialogActions>
    </Dialog>
  );
}
